import React from "react";
import { Button, Card, Form, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Label } from "reactstrap";
import Moment from "moment";

function Step3() {
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = pengajuan.detailPengajuan;
  const lamaKerjaUsaha = Moment(valDetail.stepTiga.lamaKerjaUsaha).format(
    "DD MMMM YYYY",
  );

  return (
    <div className="mt-4">
      <h4
        style={{
          fontWeight: "800",
          textTransform: "uppercase",
          color: "#2C3E50",
          fontSize: "18px",
          marginBottom: "20px",
          paddingBottom: "12px",
          borderBottom: "2px solid #f0f0f0"
        }}
      >
        Informasi Pekerjaan
      </h4>
      <div style={{ maxHeight: "550px", overflowY: "auto", overflowX: "hidden", padding: "5px" }}>
        <Row>
          {[
            {
              label: "nama pekerjaan",
              value: valDetail?.stepTiga?.namaPekerjaan,
            },
            {
              label: "status pekerjaan",
              value:
                valDetail?.stepTiga?.statusPekerjaan === "pegawai"
                  ? "Pegawai"
                  : valDetail?.stepTiga?.statusPekerjaan === "pensiun"
                    ? "Pensiun"
                    : valDetail?.stepTiga?.statusPekerjaan
                      ? "Wirausaha"
                      : null,
            },
            {
              label: "nama instansi",
              value: valDetail?.stepTiga?.namaInstansi,
            },
            {
              label: "alamat pekerjaan",
              value: valDetail?.stepTiga?.alamatPekerjaan,
            },
            {
              label: "telepon kantor",
              value: valDetail?.stepTiga?.telpKantor,
            },
            {
              label: "alamat kantor",
              value: valDetail?.stepTiga?.alamatKantor,
            },
            {
              label: "kategori jabatan",
              value:
                valDetail?.stepTiga?.kategoriJabatan === "19"
                  ? "Lainnya"
                  : valDetail?.stepTiga?.kategoriJabatan,
            },
            {
              label: "pangkat golongan",
              value: valDetail?.stepTiga?.pangkatGolongan,
            },
            { label: "lama kerja usaha", value: lamaKerjaUsaha },
            {
              label: "posisi jabatan",
              value: valDetail?.stepTiga?.posisiJabatan,
            },
            {
              label: "penghasilan bulanan",
              value: valDetail?.stepTiga?.penghasilanBulanan
                ? `Rp ${valDetail.stepTiga.penghasilanBulanan.toLocaleString("id-ID")}`
                : null,
            },
            { label: "nama usaha", value: valDetail?.stepTiga?.namaUsaha },
            {
              label: "bidang usaha",
              value: valDetail?.stepTiga?.bidangUsaha,
            },
            {
              label: "alamat usaha",
              value: valDetail?.stepTiga?.alamatUsaha,
            },
            {
              label: "omset perbulan",
              value: valDetail?.stepTiga?.omsetPerBulan
                ? `Rp ${valDetail.stepTiga.omsetPerBulan.toLocaleString("id-ID")}`
                : null,
            },
            {
              label: "keuntungan perbulan",
              value: valDetail?.stepTiga?.keuntunganPerBulan
                ? `Rp ${valDetail.stepTiga.keuntunganPerBulan.toLocaleString("id-ID")}`
                : null,
            },
            {
              label: "pengeluaran perbulan",
              value: valDetail?.stepTiga?.pengeluaranPerBulan
                ? `Rp ${valDetail.stepTiga.pengeluaranPerBulan.toLocaleString("id-ID")}`
                : null,
            },
          ].map((item, index) => (
            <Col xs={12} sm={6} lg={4} key={index} className="mb-3">
              <div 
                style={{ 
                  padding: "16px 20px", 
                  backgroundColor: "#F8FAFC", 
                  borderRadius: "14px", 
                  height: "100%", 
                  border: "1px solid #E2E8F0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#F0F9FF";
                  e.currentTarget.style.boxShadow = "0 6px 16px rgba(14, 165, 233, 0.12)";
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.borderColor = "#BAE6FD";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#F8FAFC";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.borderColor = "#E2E8F0";
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "700",
                    color: "#64748B",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px"
                  }}
                >
                  {item.label}
                </div>
                <div
                  style={{
                    fontSize: "15px",
                    color: "#1E293B",
                    fontWeight: "600",
                    textTransform: "capitalize",
                    wordBreak: "break-word",
                    lineHeight: "1.4"
                  }}
                >
                  {item.value && item.value !== "" ? item.value : <span style={{ color: "#CBD5E1" }}>-</span>}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}
export default Step3;
